import { VocabProvider } from '@vocab/react';
import type React from 'react';
import { Route, Switch } from 'react-router-dom';
import loadable from 'sku/@loadable/component';

import { getSite } from 'src/config';
import { localizedRoutesForSite, type RouteName } from 'src/routes';

import { getVocabLanguage } from '../utils/getVocabLanguage';

const AddBrand = loadable(() => import('src/components/screens/AddBrand'));
const EditBrand = loadable(() => import('src/components/screens/EditBrand'));
const ListBrands = loadable(() => import('src/components/screens/ListBrands'));
const BrandReport = loadable(
  () => import('src/components/screens/BrandReport'),
);
const PreviewBrand = loadable(
  () => import('src/components/screens/PreviewBrand'),
);

const routesConfig: Record<
  RouteName,
  {
    Component: React.ComponentType;
    exact: boolean;
  }
> = {
  listBrands: {
    Component: ListBrands,
    exact: true,
  },
  addBrand: {
    Component: AddBrand,
    exact: true,
  },
  editBrand: {
    Component: EditBrand,
    exact: false,
  },
  brandReport: {
    Component: BrandReport,
    exact: false,
  },
  previewBrand: {
    Component: PreviewBrand,
    exact: true,
  },
};

const siteRoutes = localizedRoutesForSite(getSite());

const ContentPage = () => (
  <Switch>
    {siteRoutes.map((siteRoute) => {
      if (routesConfig[siteRoute.name]) {
        const { Component, exact } = routesConfig[siteRoute.name];
        const { route, language } = siteRoute;

        return (
          <Route
            path={route}
            key={route}
            exact={exact}
            component={() => (
              <VocabProvider language={getVocabLanguage(language)}>
                <Component />
              </VocabProvider>
            )}
          />
        );
      }
    })}
  </Switch>
);

export default ContentPage;
